__turbopack_context__.v({
  "sliderContainer": "animatedTitle-module-scss-module__qPKh8a__sliderContainer",
  "sliderCount3": "animatedTitle-module-scss-module__qPKh8a__sliderCount3",
  "sliderCount3Animation": "animatedTitle-module-scss-module__qPKh8a__sliderCount3Animation",
  "sliderCount4": "animatedTitle-module-scss-module__qPKh8a__sliderCount4",
  "sliderCount4Animation": "animatedTitle-module-scss-module__qPKh8a__sliderCount4Animation",
  "sliderCount5": "animatedTitle-module-scss-module__qPKh8a__sliderCount5",
  "sliderCount5Animation": "animatedTitle-module-scss-module__qPKh8a__sliderCount5Animation",
  "sliderList": "animatedTitle-module-scss-module__qPKh8a__sliderList",
});
